import { useEffect, useState } from 'react';

interface Dimensions {
	width: number;
	height: number;
}

export const useObserverDimensionsElement = (frameRef: Element | null) => {
	const [dimensions, setDimensions] = useState<Dimensions>({
		width: 0,
		height: 0,
	});

	useEffect(() => {
		if (frameRef) {
			const updateDimensions = () => {
				setDimensions({
					width: frameRef.clientWidth,
					height: frameRef.clientHeight,
				});
			};

			updateDimensions();

			const resizeObserver = new ResizeObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.target === frameRef) {
						updateDimensions();
					}
				});
			});

			resizeObserver.observe(frameRef);

			return () => {
				resizeObserver.disconnect();
			};
		}
	}, [frameRef]);

	return dimensions;
};
